import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Contact Info`}</h1>
    <p>{`We live with our parents Alex and Esther. We can be found in the living room alongside the other members of our security firm. You can contact us via nyapathy.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      